import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { CityOfHealthService } from "./city-of-health.service";
import { inject } from "@angular/core";
import { API_MAP } from "app/core/helpers/api.map";
import { removeQueryParams } from "app/shared/components/select/helper-functions";
import { map } from "rxjs";

export const cityOfHealthResolver: ResolveFn<boolean> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    return inject(CityOfHealthService)
        .get(API_MAP.healthCity + removeQueryParams(state.url).substring(1))
        .pipe(map(() => true));
}